module.exports = __webpack_public_path__ + "static/media/3-5.118878d0.mp3";